import React from "react";
import { Link } from "react-router-dom";

export default function Disclaimer() {
  return (
    <div className="max-w-4xl mx-auto px-6 py-10 text-gray-800 leading-relaxed">
      <h1 className="text-3xl font-semibold mb-6">Disclaimer</h1>

      <p className="mb-4">
        We are a technology and data access platform that aggregates and provides property related information to brokers and similar professionals in India. We are not a party to, nor responsible for, any negotiations, agreements or transactions between brokers, property owners, buyers, tenants or any other parties.
      </p>

      <p className="mb-4">
        All property information, including availability, dimensions, prices, approvals and contact details, may be based on public sources, third-party inputs or broker contributed data, and may be incomplete, outdated or inaccurate. Users must independently verify all critical information, conduct appropriate legal, technical and commercial due diligence, and obtain professional advice before entering into any transaction.
      </p>

      <p className="mb-4">
        Users are solely responsible for their conduct, communications and representations. We shall not be liable for any claims, disputes, losses or damages arising out of or in connection with property dealings, negotiations or agreements between users or with third parties.
      </p>

      <p className="mb-4">
        We function as an intermediary under the Information Technology Act, 2000 and the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, and claims safe harbour protection for third party information and content hosted or transmitted on the platform, subject to compliance with due diligence obligations.
      </p>

      <p className="mb-4">
        Upon obtaining actual knowledge of unlawful or infringing content, We will act in accordance with applicable law and its Content Takedown Policy, including disabling access to such content within the notified timelines.
      </p>

      <p className="mb-4">
        We request you to go through our Platform Policies including{" "}
        i) <Link to="/privacy-policy" className="text-blue-600 underline">Privacy Policy</Link>,{" "}
        ii) <Link to="/broker-code-of-conduct" className="text-blue-600 underline">Broker Code of Conduct for User</Link>,{" "}
        iii) <Link to="/refund-policy" className="text-blue-600 underline">Refund Policy</Link>,{" "}
        iv) <Link to="/content-takedown-policy" className="text-blue-600 underline">Content Takedown Policy</Link>{" "}
        for your understanding.
      </p>

      <p className="mb-4"><strong>Last Updated on:</strong> 09.02.2026</p>


    </div>
  );
}
